const getHostname = (): string => window.location.hostname;

const getSearch = (): string => window.location.search;

const assignHref = (url: string): void => {
  window.location.assign(url);
};

export { getHostname, getSearch, assignHref };
